export default __webpack_public_path__ + "static/media/Agonizing Bludgeon.fea1c511.jpg";